/**
 * Leep Chás — theme core (Fase 2)
 * Alpine.js data components and global UI helpers.
 */

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

document.addEventListener('alpine:init', () => {
  Alpine.data('siteHeader', (config = {}) => ({
    menuOpen: false,
    scrolled: false,
    hidden: false,
    lastScrollY: 0,
    hideOnScroll: Boolean(config.hideOnScroll),

    init() {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    },

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
    },

    onScroll() {
      const y = window.scrollY;
      this.scrolled = y > 50;

      if (this.hideOnScroll) {
        const delta = y - this.lastScrollY;
        if (y < 80) {
          this.hidden = false;
        } else if (delta > 8) {
          this.hidden = true;
        } else if (delta < -8) {
          this.hidden = false;
        }
      }

      this.lastScrollY = y;
    },

    toggleMenu() {
      this.menuOpen ? this.closeMenu() : this.openMenu();
    },

    openMenu() {
      this.menuOpen = true;
      this.lockScroll(true);
      this.$nextTick(() => {
        const panel = this.$refs.menuPanel;
        const first = panel?.querySelector(FOCUSABLE);
        first?.focus();
      });
    },

    closeMenu() {
      this.menuOpen = false;
      this.lockScroll(false);
      this.$refs.menuToggle?.focus();
    },

    lockScroll(lock) {
      document.documentElement.classList.toggle('is-scroll-locked', lock);
      document.documentElement.toggleAttribute('data-overlay-open', lock);
    },
  }));

  document.addEventListener('leep:close-mobile-menu', () => {
    const header = document.querySelector('.site-header-group');
    if (header?._x_dataStack?.[0]?.menuOpen) {
      header._x_dataStack[0].closeMenu();
    }
  });

  Alpine.data('floatingStories', () => ({
    tooltipVisible: false,
  }));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab' || !document.documentElement.hasAttribute('data-overlay-open')) return;

  const drawer = document.querySelector('[data-mobile-menu-panel]');
  if (!drawer || !drawer.contains(document.activeElement)) return;

  const focusable = [...drawer.querySelectorAll(FOCUSABLE)].filter(
    (el) => !el.closest('[hidden]') && el.offsetParent !== null
  );
  if (focusable.length < 2) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});
